export default {
    header: {
        collect: {
            title: 'Collect',
            description:
                'Gain insights from 360 Feedback and Self-Assessment input. Choose whether feedback is shared directly by peers or only visible to you for delivery to the employee.',
        },
        review: {
            title: 'Review',
            description:
                'When conducting employee assessments, peer feedback and Self-Assessment input will be automatically included.',
        },
        aiAnalysis: {
            title: 'AI Analysis & Share',
            description:
                'AI will analyze and summarize peer feedback to support your employee discussions. It will be seamlessly integrated into your meeting plan.',
        },
    },
    reviewsToBeLaunched: {
        title: 'Reviews to be launched',
        description:
            'You can launch a review at any time. The next reviews scheduled by the organization will appear here when available.',
        prepareForLaunch: 'Prepare for launch',
        new360Review: 'New 360 Feedback',
        createNewEvaluation: 'Launch an Evaluation',
        revieweeBadge: {
            comingSoon: 'Coming soon',
            profile: 'Profile',
            noAssignedProfile: 'None',
        },
    },
    ongoingReviews: {
        title: 'Ongoing Reviews',
        description: 'Your team is working on these reviews. Track progress as responses come in.',
        ongoingIllustrationAlt: 'Illustration of ongoing reviews',
        sendReminders: 'Send Reminders',
        sendRemindersConfirm_one:
            'Send a reminder to the {{count}} person who has not answered yet?',
        sendRemindersConfirm_other:
            'Send a reminder to the {{count}} people who have not answered yet?',
        evaluationPeriodTitle: 'Annual evaluation {{year}}',
        noEvaluationPeriod: 'No reference period',
    },
    pastReviews: {
        title: 'Past Reviews',
        description: 'Explore past reviews completed for your employees.',
        pastIllustrationAlt: 'Illustration of past reviews',
        completed: 'Completed',
        completedOn: 'Completed on {{date}}',
    },
    toBeLaunchedAlt: 'Illustration of reviews to be launched',
    ongoingAlt: 'Illustration of ongoing reviews',
    pastAlt: 'Illustration of past reviews',
    onSuccessDelete: 'Review deleted successfully',
    onSuccessSendReminders: 'Reminders sent successfully',
    viewResults: 'View Results',
    noFilterResults: 'No results match your filters',
};
